//workflows

const workflowsPath = (isDefaultPath?: boolean) => (!isDefaultPath ? 'workflows' : '/workflows');
const workflowCreatePath = (workflowId?: string): string => {
    if (!workflowId) {
        return 'workflows/:workflowId';
    } else return `/workflows/${workflowId}`;
};
const newWorkflowCreatePath = (isDefaultPath?: boolean) => (!isDefaultPath ? 'workflowCreate' : '/workflowCreate');

const welcomePagePath = (isDefaultPath?: boolean) => (!isDefaultPath ? 'welcome-page' : '/welcome-page');

const profilePagePath = (isDefaultPath?: boolean) => (!isDefaultPath ? 'profile' : '/profile');

// Datasets

const dataPagePath = (isDefaultPath?: boolean) => (!isDefaultPath ? 'data' : '/data');
const uploadDataPagePath = (isDefaultPath?: boolean) => (!isDefaultPath ? 'data/uploadDataset' : '/data/uploadDataset');
const uploadDatasetDetailsPath = (dataSetId?: string): string => {
    if (!dataSetId) {
        return 'data/:dataSetId/details';
    } else return `/data/${dataSetId}/details`;
};

const uploadDatasetUpadatePath = (dataSetId?: string): string => {
    if (!dataSetId) {
        return 'data/:dataSetId/details/update';
    } else return `/data/${dataSetId}/details/update`;
};
const uploadDatasetFileListPath = (dataSetId?: string): string => {
    if (!dataSetId) {
        return 'data/:dataSetId/details/fileList';
    } else return `/data/${dataSetId}/details/fileList`;
};
const uploadDatasetFilePath = (dataSetId?: string, filePath?: string): string => {
    if (!dataSetId) {
        return 'data/:dataSetId/details/fileList/:filePath/edit';
    } else return `/data/${dataSetId}/details/fileList/${filePath}/edit`;
};

const workflowDatasetsPagePath = (isDefaultPath?: boolean) =>
    !isDefaultPath ? 'workflowDataSets' : '/workflowDataSets';
const workflowUploadDatasetDetailsPath = (dataSetId?: string): string => {
    if (!dataSetId) {
        return 'workflowDataSets/:dataSetId/details';
    } else return `/workflowDataSets/${dataSetId}/details`;
};

const workflowUploadDatasetUpadatePath = (dataSetId?: string): string => {
    if (!dataSetId) {
        return 'workflowDataSets/:dataSetId/details/update';
    } else return `/workflowDataSets/${dataSetId}/details/update`;
};

const workflowUploadDatasetFileListPath = (dataSetId?: string): string => {
    if (!dataSetId) {
        return 'workflowDataSets/:dataSetId/details/fileList';
    } else return `/workflowDataSets/${dataSetId}/details/fileList`;
};

const workflowUploadDatasetFilePath = (dataSetId?: string, filePath?: string): string => {
    if (!dataSetId) {
        return 'workflowDataSets/:dataSetId/details/fileList/:filePath/edit';
    } else return `/workflowDataSets/${dataSetId}/details/fileList/${filePath}/edit`;
};

export const error500Path = (isDefaultPath?: boolean) => (!isDefaultPath ? '500' : '/maintenance/500');
export const error404Path = (isDefaultPath?: boolean) => (!isDefaultPath ? '404' : '/maintenance/404');

export {
    workflowsPath,
    workflowCreatePath,
    welcomePagePath,
    profilePagePath,
    newWorkflowCreatePath,
    dataPagePath,
    uploadDataPagePath,
    uploadDatasetDetailsPath,
    uploadDatasetUpadatePath,
    uploadDatasetFileListPath,
    uploadDatasetFilePath,
    workflowDatasetsPagePath,
    workflowUploadDatasetDetailsPath,
    workflowUploadDatasetUpadatePath,
    workflowUploadDatasetFileListPath,
    workflowUploadDatasetFilePath,
};
